












import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import { InjectReactive } from 'vue-property-decorator'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import BaseTooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'
import TicketStatusView from '@/modules/ticket/components/shared/TicketStatusView.vue'
import { TicketCollectionTypeInAdmin, TicketCollectionWithModel } from '@/modules/ticket/models/ticket-collection.model'
import AdminTicketActions from '@/modules/ticket/components/admin/table/AdminTicketActions.vue'
import EllipsisLink from '@/modules/shared/components/shared/utils/EllipsLink.vue'
import { AdminTicketRoute } from '@/modules/ticket/routes/admin-ticket.route'
import { PersonTitle } from '@/modules/common/person/models/PersonResource.model'

@Component({
  components: {
    AdminUserInfoButton,
    CopyableText,
    TextEllipsis,
    TesTr,
    TesTd,
    DateTooltipped,
    BaseTooltip
  }
})
export default class AdminTicketTableRow extends mixins<TesTableRow>(TesTableRow) {
  constructor(
    private readonly routes: AdminTicketRoute
  ) {
    super()
  }

  personTitle = PersonTitle

  @InjectReactive()
  tickets!: TicketCollectionTypeInAdmin

  get fixedData(): TicketCollectionWithModel {
    return {
      statuses: this.tickets.statuses,
      default_filters: this.tickets.default_filters,
      persons: this.tickets.persons
    }
  }

  columnComponents = {
    title: {
      component: EllipsisLink,
      handler: (value, row) => ({ href: this.routes.show(row.id), text: row.title })
    },
    department: {
      component: TextEllipsis,
      handler: (value, row) => ({ text: row.department.title })
    },
    status: {
      component: TicketStatusView,
      handler: (value, row, withData) => ({ status: row.status, statuses: withData.statuses })
    },
    last_answer_date: {
      component: DateTooltipped,
      handler: (value) => ({ isoDate: value })
    },
    last_answer_user: {
      component: AdminUserInfoButton,
      handler: (value, row) => ({ basicUser: row.last_answer_user })
    },
    // user: {
    //   component: AdminUserInfoButton,
    //   handler: (value, row) => ({ basicUser: row.user })
    // },
    actions: {
      component: AdminTicketActions,
      handler: (value, row, withData) => ({ ticket: row, withData: withData })
    }
  }

}
